export const canUserAccessSetupModule = (user) => {
  if (typeof user !== 'object') throw new Error('Must be a object');

  return user.email.includes('@stilingue.com.br');
};
